import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import MainButton from "../components/common/mainButton";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import { api } from "../../config";
import Loading from "../components/common/loading";
import store from "../redux/store";
import * as Actions from "../redux/actions";
import BreadCrumb from "../components/common/breadCrumb";
import SearchContentInput from "../components/common/search-content-input";
import { useTranslation } from "react-i18next";
import Modal from "../components/common/modal";

const GetMarcas = ({ marcas }) => {

  let { pathname } = useLocation();

  const { t } = useTranslation(["data"]);

  return marcas.map((element, i) => {
    
    return (
      <div key={i} className="block">
        <div className="background">
          <img src={`${api.media.images}${element.code}-cover`} />
        </div>
        <div className="button">
          <MainButton
            link={`${pathname}/${element.code}`}
            name={t("verProductos")}
          />
        </div>
      </div>
    );
  });
};

const Marcas = () => {

  let { pathname } = useLocation();

  const getRoute = pathname.split("/").filter((el) => el);

  const [marcas, setMarcas] = useState();

  const { t } = useTranslation(["data"]);

  let { catalogoId, categoriaId } = useParams();

  const [openPopup, setOpenPopup] = useState(false);

  const [popup, setPopup] = useState(null);

  const { findPopup } = useSelector((state) => state.catalog);

  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);

    store.dispatch(Actions.getMarcas(catalogoId, categoriaId)).then((data) => {

      const marcas = data.payload.data;

      if (marcas.length === 1) {

        const route = catalogoId
          ? `/catalogos/${catalogoId}/${categoriaId}/${marcas[0].code}`
          : `/categorias/${categoriaId}/${marcas[0].code}`;

        navigate(route);

      } else {

        setMarcas(marcas);
        setLoading(false);

      }
    });
  }, []);

  useEffect(() => {
    setPopup(findPopup);
  }, [findPopup]);

  return (<>
    {!marcas && loading && <Loading />}

    <div className="marcas-container">

      {!loading && marcas && (
        <div className="marcasTitle">
          {t("porMarcas")}{" "}
          {popup && getRoute[0] !== "search" && getRoute[0] !== "marcas" && (
            <div onClick={() => setOpenPopup(!openPopup)} className="popUp">
              <img src="/assets/img/informacion.png" />
            </div>
          )}
          {/* {(popup && 
        (popup.category !== "" && !popup.category.name[categoriaId] || popup.brand !== "" && !popup.brand.name[marcaId]) && 
        getRoute[0] !== "search") && 
        getRoute[0] !== "marcas" && 
        <div className="popUp" 
        onClick={() => setOpenPopup(!openPopup)}>
          <img src="/assets/img/informacion.png" />
        </div>
          } */}
        </div>
      )}

      {openPopup && (
        <Modal
          popup={popup}
          setOpenPopup={setOpenPopup}
          openPopup={openPopup}
        />
      )}

      {!loading && getRoute && getRoute.length > 1 && (
        <div className="bread">
          <BreadCrumb />
          {getRoute[0] === "search" && getRoute.length === 1 ? (
            <div className="search-content">
              <SearchContentInput route={getRoute} />
            </div>
          ) : (
            ""
          )}
        </div>
      )}

      {marcas && !loading && (
        <div className="content">{<GetMarcas marcas={marcas} />}</div>
      )}

    </div>
    </>
  );
};

export default Marcas;
